export default __webpack_public_path__ + "static/media/0.95f44237.mp4";